//Import Mixpanel SDK
import mixpanel from "mixpanel-browser";
import { useEffect } from "react";
import { Platform } from "react-native";

import { getExpoEASConstant } from "@/utils/expoConstants";

import { isAnalyticsTrackingAllowed } from "../../analyticsTrackingConsent";
import { validMixpanelEnvs } from "../../types";

let hasInitializedMixpanel = false;

export const useInitializeMixpanel = () => {
  useEffect(() => {
    initializeMixpanel();
  });
};

export const initializeMixpanel = () => {
  const env = getExpoEASConstant("deployEnv");
  const token = getMixpanelProjectToken(env);
  if (
    hasInitializedMixpanel ||
    !isAnalyticsTrackingAllowed() ||
    !validMixpanelEnvs.includes(env) ||
    Platform.OS !== "web" ||
    !token
  ) {
    return;
  }

  mixpanel.init(token, {
    debug: false,
    track_pageview: false,
    persistence: "localStorage",
  });
  hasInitializedMixpanel = true;
};

/**
 *
 * These ensure we can test flows with demo/local without pollutting prod data.
 * It is not necessary to obfuscate these in an env file because they are exposed in the api calls anyhow
 * IF we don't hit a specific env -- we do not track anything. This avoids staging etc. from tracking
 * analytics events.
 */
const getMixpanelProjectToken = (env: string) => {
  if (env === "prod") {
    return "b441f7474da9f1aa128d84e47c55938a";
  } else if (env === "demo") {
    return "d3feaaeb65155e09549e5521ec6a77b9";
  } else if (env === "local") {
    return "f2d96225b2a6645b2186bf876616e4f0";
  }
};
